// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SgbX","comment":"styles_comment__P6Z0S"};